import * as identify from "utils/treeUtils";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

interface DisabeDropProps {
  parentNode: NodeApi;
  dragNodes: NodeApi[];
  index?: number;
}

export const disableDrop = ({
  parentNode,
  dragNodes,
  index = 0,
}: DisabeDropProps): boolean => {
  const dragNode: NodeApi = dragNodes[0];

  // Cases where drop is disabled
  // if new parent node is a wizard item
  const toWizard = identify.isWizard(parentNode?.data);
  // if new parent node is a TROX netcom item
  const toTroxnetcom = identify.isTroxNetcom(parentNode?.data);
  // if new parent node is product
  const toProduct = identify.isAnyProduct(parentNode?.data);
  // if new parent node is the tree root and the drag node is a configuration
  const productToRootFolder =
    identify.isRoot(parentNode?.data) && identify.isAnyProduct(dragNode?.data);
  // if new parent node is the same as drag node's parent and drag node is configuration
  // const configToSameParent =
  //   parentNode.data.id === dragNode.data.parentId &&
  //   dragNode.data.kind === nodeTypes.CONFIGURATION;
  // if new parent node has a level less than 0
  const isNotValidNodeLevel = parentNode.level < 0;
  // if the drag node is a folder being dropped between or above configurations
  const folderBetweenOrAboveProducts =
    index > 0 &&
    identify.isAnyProduct(
      parentNode.children && parentNode?.children[index]?.data,
    ) &&
    identify.isAnyFolder(dragNode?.data);
  // if the drag node is a configuration being dropped between or below folders
  const productBetweenOrBelowFolders =
    index > 0 &&
    identify.isAnyFolder(
      parentNode?.children && parentNode?.children[index - 1]?.data,
    ) &&
    identify.isAnyFolder(
      parentNode?.children && parentNode?.children[index]?.data,
    ) &&
    identify.isAnyProduct(dragNode?.data);
  // const configBetweenConfigs =
  //   index > 0 &&
  //   parentNode?.children[index]?.data?.kind === nodeTypes.CONFIGURATION &&
  //   dragNode?.data?.kind === nodeTypes.CONFIGURATION;

  if (
    isNotValidNodeLevel ||
    folderBetweenOrAboveProducts ||
    productBetweenOrBelowFolders ||
    toWizard ||
    toTroxnetcom ||
    toProduct ||
    productToRootFolder
  ) {
    return true;
  }
  return false;
};
